<script setup lang="ts">
import Logo from "../assets/vector/logo.svg";
import LogoDark from "../assets/vector/logo-dark.svg";
import UiNavLink from "./UiNavLink.vue";

const props = withDefaults(defineProps<{
    dark?: boolean,
    size?: 'md' | 'lg' | 'auto',
    logoClass?: string
}>(), {
    size: 'lg',
    class: '',
});

const sizeClasses = {
    md: 'w-[130px]',
    lg: 'w-[155px]',
    auto: '',
};
</script>

<template>
    <UiNavLink to="/" aria-label="shopexperts home">
        <div :class="sizeClasses[props.size]">
            <LogoDark v-if="props.dark" :class="props.logoClass" />
            <Logo  v-else :class="props.logoClass" />
        </div>
    </UiNavLink>
</template>
